import { storeToRefs } from 'pinia'

import { useBetaPreviewUIStore } from '../stores/beta-preview.ui-store'

export const useBetaPreview = () => {
  const store = useBetaPreviewUIStore()
  const { showBetaPreview, isShowBetaPreviewEnabled } = storeToRefs(store)

  return {
    showBetaPreview,
    isShowBetaPreviewEnabled,
    setShowBetaPreview: store.setShowBetaPreview,
    clearShowBetaPreview: store.clearShowBetaPreview,
  }
}
